/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
'use strict';
const ButtonLoader = {

	$domLinkClass: $('.magazine-cards__view-more-btn>.btn'),
	ShowClass: $('showLoader'),
	init: function() {
		this.showLoader();
	},

	showLoader: function() {
		ButtonLoader.$domLinkClass.on('click', function() {
			if ($(this).hasClass('showLoader')) {
				$(this).removeClass('showLoader');
			} else {
				$(this).addClass('showLoader');
			}

			setTimeout(() => {
				$(this).removeClass('showLoader');
			}, '3000');
		});


	}
};

export default ButtonLoader;
